module.exports = __webpack_public_path__ + "static/img/icon_login_logo.87126ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_login_logo.png
// module id = bM32
// module chunks = 5